import React from "react";
import { AbsoluteFill, interpolate, spring, useCurrentFrame, useVideoConfig } from "remotion";
import { COLORS, FONTS, SPRING } from "./constants";
import { Backdrop, glow } from "./shared";
import { RainbowEAKC } from "../shared/RainbowEAKC";

export const Scene02Title: React.FC = () => {
  const frame = useCurrentFrame();
  const { fps, durationInFrames } = useVideoConfig();

  const fade = interpolate(frame, [durationInFrames - 30, durationInFrames], [1, 0], {
    extrapolateLeft: "clamp", extrapolateRight: "clamp",
  });

  const titleSp = spring({ frame, fps, config: SPRING.bouncy });
  const titleScale = interpolate(titleSp, [0, 1], [0.5, 1], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });
  const titleOp = interpolate(titleSp, [0, 1], [0, 1], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });

  const subSp = spring({ frame: frame - 30, fps, config: SPRING.gentle });
  const subOp = interpolate(subSp, [0, 1], [0, 1], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });

  const taglineSp = spring({ frame: frame - 75, fps, config: SPRING.gentle });
  const taglineOp = interpolate(taglineSp, [0, 1], [0, 1], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });

  const ringAngleDeg = frame * 0.5;

  return (
    <AbsoluteFill style={{ background: COLORS.bg, opacity: fade, overflow: "hidden" }}>
      <Backdrop frame={frame} accent={COLORS.neonPurple} />

      {/* 3D orb ring around title */}
      <div style={{
        position: "absolute", top: "50%", left: "50%",
        width: 0, height: 0, perspective: 1400,
      }}>
        <div style={{ transform: `rotateX(${Math.sin(frame * 0.03) * 3}deg) rotateY(${ringAngleDeg * 0.1}deg)` }}>
          {[...Array(10)].map((_, i) => {
            const ang = (ringAngleDeg + i * 36) * Math.PI / 180;
            const rx = 640, ry = 180;
            const x = Math.cos(ang) * rx;
            const y = Math.sin(ang) * ry;
            const inFront = Math.sin(ang) > 0;
            const depth = inFront ? 1 : 0.6;
            const colors = [COLORS.neonPink, COLORS.neonBlue, COLORS.neonGreen, COLORS.neonOrange, COLORS.neonPurple, COLORS.neonCyan, COLORS.neonYellow, COLORS.neonRed, COLORS.neonLime, COLORS.neonPink];
            const c = colors[i];
            return (
              <div key={i} style={{
                position: "absolute",
                left: x - 14, top: y - 14,
                width: 28, height: 28,
                borderRadius: "50%",
                background: `radial-gradient(circle, ${c}, ${c}00)`,
                boxShadow: `0 0 30px ${c}, 0 0 60px ${c}77`,
                transform: `scale(${depth})`,
                zIndex: inFront ? 10 : 1,
                opacity: titleOp,
              }} />
            );
          })}
        </div>
      </div>

      {/* EAKC rainbow title */}
      <div style={{
        position: "absolute", inset: 0,
        display: "flex", flexDirection: "column",
        alignItems: "center", justifyContent: "center",
        zIndex: 5,
      }}>
        <RainbowEAKC
          id="mb-title"
          frame={frame}
          fontSize={260}
          fontFamily={FONTS.heading}
          scale={titleScale}
          opacity={titleOp}
          glowColor={COLORS.neonPurple}
        />

        <div style={{
          fontSize: 44,
          fontFamily: FONTS.heading,
          fontWeight: 600,
          color: COLORS.neonCyan,
          marginTop: 18,
          opacity: subOp,
          textShadow: glow(COLORS.neonCyan, true),
          letterSpacing: 3,
        }}>
          Your Company's Brain
        </div>

        <div style={{
          fontSize: 24,
          fontFamily: FONTS.body,
          color: COLORS.textSecondary,
          marginTop: 24,
          opacity: taglineOp,
          letterSpacing: 1,
          fontWeight: 500,
        }}>
          Built for the 63 million SMEs nobody else is serving.
        </div>
      </div>
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
